(function enableChatAvoidance() {
  // An uninstalled Chat must not start CTA scans, polling or page-wide listeners.
  if (!document.querySelector("shopify-chat")) {
    window.customElements?.whenDefined("shopify-chat").then(() => {
      if (document.querySelector("shopify-chat")) {
        enableChatAvoidance();
        return;
      }
      // Registration may precede insertion. Inspect only newly added subtrees.
      let waiting = true;
      const insertionObserver = new MutationObserver((records) => {
        if (
          !waiting ||
          !records.some((record) =>
            Array.from(record.addedNodes).some(
              (node) =>
                node.nodeType === 1 &&
                (node.localName === "shopify-chat" ||
                  node.querySelector("shopify-chat")),
            ),
          )
        )
          return;
        waiting = false;
        insertionObserver.disconnect();
        enableChatAvoidance();
      });
      insertionObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    });
    return;
  }

  const mobile = window.matchMedia("(width < 990px)");
  const className = "pm-chat-clear-control";
  const persistentControls =
    "#Cart-note, #CartDrawer-Note, .prepme-min-order, .prepme-drawer-min-order, .Avada-CookiesBar__Reopen-Popup";
  const desktopSelector =
    ".pm6-product .pm-nutrition-container, " + persistentControls;
  const actionSelector =
    ".pm6-home .pm6-button, .pm6-home__product-link, .pm6-home__text-link, " +
    ".pm6-home__hero-secondary, .pm6-home__hero-note, .pm6-home__hero-detail, " +
    ".pm6-collection-nav a, .pm6-home__faq summary, " +
    ".product-card-wrapper .card__actions .card-product-btn, .pm6-blog__title a, " +
    "footer.pmf a, footer.pmf input:not([type='hidden']), footer.pmf button, " +
    "footer.pmf .pmf__payments .list-payment__item, " +
    ".product-card-wrapper .card__heading a, .product-card-wrapper .card__description, " +
    ".pm-card-nutrition .pm-nutrition, .pm-card-nutrition .pm-nutrition__heading, " +
    "main form input:not([type='hidden']), main form textarea, main form select, main form button, " +
    ".cart__checkout-button, .pm6-contact__method, " +
    persistentControls +
    ", " +
    ".pm6-product .price, .pm6-product .product-form__submit, " +
    ".pm6-product .product-form__input label, .pm6-product .pm-nutrition-container, " +
    ".pm6-product .pm-nutrition, .pm6-product .pm-nutrition__heading, " +
    ".pm6-product .product__description, .pm6-product .pm6-product__short-description, " +
    ".pm6-product .pm-sub-intro--details, .pm-wkp__desc, " +
    ".pm6-blog__body, .article-template__content, .pm-about__manifesto-quote, " +
    ".prepme-assurance, .prepme-monthly-summary, .product__accordion summary, " +
    ".pm-wkp__price-wrap, .pm-wkp__var-btn, .pm-wkp__atc-btn, " +
    "meal-picker-modal[open] button";
  let scheduled = false;
  let observedActivator;
  let activatorObserver;
  let observedChatRoot;
  let chatRootObserver;
  let observedRuntimeRoot;
  let runtimeRootObserver;
  const observedPickers = new WeakSet();

  function observePickers() {
    document.querySelectorAll("meal-picker-modal").forEach((picker) => {
      if (observedPickers.has(picker)) return;
      observedPickers.add(picker);
      const observer = new MutationObserver(schedule);
      observer.observe(picker, {
        attributes: true,
        attributeFilter: ["open"],
        childList: true,
        subtree: true,
      });
    });
    schedule();
  }

  const getActivator = (chat) =>
    chat?.shadowRoot?.querySelector('[part="activator"]') ||
    chat?.shadowRoot
      ?.querySelector("shopify-agent-runtime")
      ?.shadowRoot?.querySelector('[part="activator"]');

  const overlaps = (a, b) =>
    a.left < b.right &&
    a.right > b.left &&
    a.top < b.bottom &&
    a.bottom > b.top;

  function setClearControl(clear) {
    document.documentElement.classList.toggle(className, clear);
    const chat = document.querySelector("shopify-chat");
    if (chat) chat.inert = clear;
  }

  function update() {
    scheduled = false;
    // Cart notes, checkout notices and privacy access can meet Chat on desktop.
    const protectedSelector = mobile.matches ? actionSelector : desktopSelector;
    if (!document.querySelector(protectedSelector)) {
      setClearControl(false);
      return;
    }

    const chat = document.querySelector("shopify-chat");
    const chatRoot = chat?.shadowRoot;
    const runtimeRoot = chatRoot?.querySelector(
      "shopify-agent-runtime",
    )?.shadowRoot;
    const activator = getActivator(chat);

    if (chatRoot && chatRoot !== observedChatRoot) {
      chatRootObserver?.disconnect();
      observedChatRoot = chatRoot;
      chatRootObserver = new MutationObserver(schedule);
      chatRootObserver.observe(chatRoot, { childList: true, subtree: true });
    }

    if (runtimeRoot && runtimeRoot !== observedRuntimeRoot) {
      runtimeRootObserver?.disconnect();
      observedRuntimeRoot = runtimeRoot;
      runtimeRootObserver = new MutationObserver(schedule);
      runtimeRootObserver.observe(runtimeRoot, {
        childList: true,
        subtree: true,
      });
    }

    if (activator && activator !== observedActivator) {
      activatorObserver?.disconnect();
      observedActivator = activator;
      activatorObserver = new MutationObserver(schedule);
      activatorObserver.observe(activator, {
        attributes: true,
        attributeFilter: ["aria-expanded"],
      });
    }

    if (
      !activator ||
      activator.getAttribute("aria-expanded") === "true" ||
      activator.getRootNode().activeElement === activator
    ) {
      setClearControl(false);
      return;
    }

    const chatRect = activator.getBoundingClientRect();
    const obstructsAction = Array.from(
      document.querySelectorAll(protectedSelector),
    ).some((action) => overlaps(chatRect, action.getBoundingClientRect()));
    setClearControl(obstructsAction);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }

  function start() {
    document.addEventListener("scroll", schedule, {
      passive: true,
      capture: true,
    });
    window.addEventListener("resize", schedule, { passive: true });
    mobile.addEventListener("change", schedule);
    document.addEventListener("shopify:section:load", observePickers);
    document.addEventListener("focusin", schedule);
    document.addEventListener("focusout", schedule);
    // Drawer controls move after focus/toggle; check their final animated position.
    document.addEventListener("toggle", schedule, true);
    document.addEventListener(
      "transitionend",
      (event) => {
        if (event.target?.closest?.("menu-drawer")) schedule();
      },
      true,
    );
    observePickers();
    // Section/AJAX updates can add or move controls without a scroll event.
    // Observe markup only, not attributes: toggling our class must not loop.
    const main = document.querySelector("main");
    if (main) {
      const contentObserver = new MutationObserver(observePickers);
      contentObserver.observe(main, { childList: true, subtree: true });
    }

    let attempts = 0;
    function waitForActivator() {
      schedule();
      if (getActivator(document.querySelector("shopify-chat"))) return;
      if (++attempts < 40) window.setTimeout(waitForActivator, 250);
    }
    if (document.querySelector(actionSelector)) waitForActivator();
    else schedule();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
